<template>
  <fieldset :class="_fs_class">
    <cat-label
      :fieldset="true"
      :label="label"
      :label-id="id + '_lbl'"
      :optional="!mandatory"
      :display-required="legendMandatory || !mandatory"
      :errors="errors"
      :readonly="readonly"
      :inline="help && !!help.url"
    ></cat-label>
    <cat-help-trigger
      v-if="help && help.url"
      :source-id="id"
      :url="help.url"
      :title="label"
    />
    <div v-if="help && help.url" class="clearfix"></div>
    <cat-hint :id="id + '_hint'" :text="hint" />
    <cat-help
      v-if="help && help.text"
      :id="id"
      :heading="help.title"
      :text="help.text"
      class="mbt"
      :aria-describedby="label && id ? id + '_lbl' : null"
    />
    <slot></slot>
    <div :class="_ih_class">
      <div :style="'width: ' + parseInt(firstPercent) + '%;'">
        <slot name="field-one"></slot>
      </div>
      <div :style="'width: ' + _secondPercent + '%;'">
        <slot name="field-two"></slot>
      </div>
      <div
        :style="
          'width: ' + (100 - (parseInt(firstPercent) + _secondPercent)) + '%;'
        "
      >
        <slot name="field-three"></slot>
      </div>
    </div>
    <slot name="after-input"></slot>
    <cat-errors :errors="errors" />
  </fieldset>
</template>

<script lang="ts">
import { defineComponent, inject, provide } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import CatErrors from "@/components/catErrors/catErrors.vue";
import CatHelp from "@/components/utilities/help.vue";
import CatLabel from "@/components/utilities/cat-label.vue";
import CatHint from "@/components/utilities/hint.vue";
import CatHelpTrigger from "@/components/catPageTemplate/catHelpTrigger.vue";

export default defineComponent({
  setup(props) {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);
    const displayParams = inject("displayParams", false);

    const showOptionals =
      props.mandatory ||
      (displayParams ? displayParams.showOptionalOnGroupFields : false);
    provide("showOptionals", showOptionals);

    return {
      resolveTxt,
      displayParams
    };
  },
  name: "CatThreeFields",
  components: {
    CatErrors,
    CatHelp,
    CatLabel,
    CatHelpTrigger,
    CatHint
  },
  props: {
    id: [String, Number],
    label: [String],
    hint: [String],
    mandatory: {
      type: [Boolean],
      default: false
    },
    legendMandatory: {
      type: Boolean,
      default: false,
      description:
        "Indicates if the mandatory indicator should show in the legend. By default, the required indicator is not displayed on the legend."
    },
    errors: [Array],
    readonly: [Boolean],
    firstPercent: {
      type: [Number, String],
      default: 33.33,
      validator: function (value) {
        return value > 90 || value < 10 ? 33.33 : value;
      }
    },
    secondPercent: {
      type: [Number, String],
      default: 33.33,
      validator: function (value) {
        return value > 90 || value < 10 ? 33.33 : value;
      }
    },
    margin: [Boolean, String],
    size: [String],
    help: [Object]
  },
  computed: {
    _ih_class: function () {
      const css = {
        "input-holder": true
      };
      if (this.size) {
        css[this.size] = true;
      }
      return css;
    },
    _fs_class: function () {
      var css = {
        fieldset: true,
        "combo combo-3": true,
        invalid:
          this.errors &&
          this.errors.length > 0 &&
          this.errors.some(function (r) {
            return r.level <= 1;
          }),
        optional: !this.mandatory,
        mandatory: this.mandatory,
        "readonly-list": this.readonly,
        separate: this.margin
      };
      if (this.size) {
        css[this.size] = true;
      }
      css.warning =
        this.errors &&
        this.errors.length > 0 &&
        this.errors.some(function (r) {
          return r.level == 2 && !css.invalid;
        });
      css.infomessage =
        this.errors &&
        this.errors.length > 0 &&
        this.errors.some(function (r) {
          return r.level == 3 && !css.invalid;
        });
      css.debugmessage =
        this.errors &&
        this.errors.length > 0 &&
        this.errors.some(function (r) {
          return r.level == 4;
        });
      // if (this.firstPercent) {
      //   var first = parseInt(this.firstPercent);
      //   var second = parseInt(this.secondPercent);
      //   if (!isNaN(first) && !isNaN(second)) {
      //     if (first > 90 || first < 10) {
      //       console.log('Invalid percentage. Ignoring', first);
      //     } else {
      //       var third = first === 33 && second === 33 ? 33 : 100 - (first + second);
      //       css['combo-fluid--' + first + '-' + second + '-' + third] = true;
      //     }
      //   }
      // }
      return css;
    },

    _secondPercent: function () {
      var first = parseInt(this.firstPercent);
      var second = parseInt(this.secondPercent);

      return first + second > 95 ? 95 - first : second; //if first and second is more than 95 then chop the second one and leave 5% for third
    }
  }
});
</script>
